<template>
  <div class="agreement-container">
    <div class="agreement-header">
      <h2>客户协议管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="handleAddAgreement">新增协议</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="agreementList"
      border
      style="width: 100%">
      <el-table-column
        prop="title"
        label="协议标题"
        min-width="250">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑协议对话框 -->
    <el-dialog 
      :title="dialogStatus === 'create' ? '新增协议' : '编辑协议'" 
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleDialogClose"
      @opened="onDialogOpened">
      <el-form :model="agreementForm" :rules="rules" ref="agreementForm" label-width="100px">
        <el-form-item label="协议标题" prop="title">
          <el-input v-model="agreementForm.title" placeholder="请输入协议标题"></el-input>
        </el-form-item>
        <el-form-item label="协议内容" prop="content">
          <div class="editor-container">
            <div ref="editor"></div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import E from 'wangeditor'
import adminApi from '@/api/adminApi'

export default {
  name: 'AgreementManage',
  data() {
    return {
      loading: false,
      agreementList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogStatus: 'create',
      agreementForm: {
        id: '',
        title: '',
        content: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入协议标题', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入协议内容', trigger: 'blur' }
        ]
      },
      editor: null,
      apiUrl: adminApi.ApiUrl || '' // 保存API URL
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    // 获取API URL
    if (adminApi.ApiUrl) {
      this.apiUrl = adminApi.ApiUrl
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      
      try {
        const res = await adminApi.getAgreementListByPage({
          currentPage: this.currentPage,
          pageSize: this.pageSize
        })
        console.log('获取协议列表成功:', res)
        this.agreementList = res.data.data.list ? res.data.data.list || [] : []
        this.total = res.data.data ? res.data.data.total || 0 : 0
      } catch (error) {
        console.error('获取协议列表失败:', error)
        this.$message.error('获取协议列表失败: ' + (error.message || '未知错误'))
        this.agreementList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },
    // 初始化富文本编辑器
    initEditor() {
      try {
        // 确保当前没有编辑器实例
        this.destroyEditor()
        
        // 使用setTimeout确保DOM已完全渲染
        setTimeout(() => {
          // 确认ref元素存在
          if (!this.$refs.editor) {
            console.error('编辑器容器元素不存在')
            return
          }
          
          // 创建新的编辑器实例
          const editor = new E(this.$refs.editor)
          
          // 配置菜单
          editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            'emoticon',
            'table',
            'code',
            'undo',
            'redo'
          ]
          
          // 监听编辑器内容变化
          editor.config.onchange = (html) => {
            this.agreementForm.content = html
          }
          
          // 创建编辑器
          editor.create()
          this.editor = editor
          
          // 设置编辑器内容
          if (this.dialogStatus === 'update' && this.agreementForm.content) {
            this.editor.txt.html(this.agreementForm.content)
          } else {
            this.editor.txt.html('')
          }
        }, 100)
      } catch (error) {
        console.error('初始化编辑器失败:', error)
      }
    },
    
    // 销毁编辑器
    destroyEditor() {
      if (this.editor && this.editor.destroy) {
        try {
          this.editor.destroy()
          this.editor = null
        } catch (error) {
          console.error('销毁编辑器失败:', error)
        }
      }
    },
    
    // 对话框打开后的回调
    onDialogOpened() {
      this.initEditor()
    },
    
    // 关闭对话框
    closeDialog() {
      this.dialogVisible = false
    },
    
    // 新增协议
    handleAddAgreement() {
      this.dialogStatus = 'create'
      this.agreementForm = {
        id: '',
        title: '',
        content: ''
      }
      this.dialogVisible = true
    },
    
    // 编辑协议
    handleEdit(row) {
      this.dialogStatus = 'update'
      this.agreementForm = {
        id: row.id,
        title: row.title,
        content: row.content
      }
      this.dialogVisible = true
    },
    
    // 删除协议
    handleDelete(row) {
      this.$confirm('确认删除该协议?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminApi.deleteAgreement(row.id).then(res => {
          console.log('删除返回数据:', res)
          if (res) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(err => {
          console.error('删除协议失败', err)
          this.$message.error('删除协议失败')
        })
      }).catch(() => {
        // 取消删除
      })
    },
    // 提交表单
    submitForm() {
      this.$refs.agreementForm.validate(valid => {
        if (valid) {
          if (this.dialogStatus === 'create') {
            // 创建协议
            adminApi.createAgreement(this.agreementForm).then(res => {
              console.log('创建返回数据:', res)
              if (res) {
                this.$message.success('创建成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(res.msg || '创建失败')
              }
            }).catch(err => {
              console.error('创建协议失败', err)
              this.$message.error('创建协议失败')
            })
          } else {
            // 更新协议
            adminApi.updateAgreement(this.agreementForm).then(res => {
              console.log('更新返回数据:', res)
              if (res) {
                this.$message.success('更新成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(res.msg || '更新失败')
              }
            }).catch(err => {
              console.error('更新协议失败', err)
              this.$message.error('更新协议失败')
            })
          }
        }
      })
    },
    // 关闭对话框前的回调
    handleDialogClose(done) {
      this.$confirm('确认关闭？未保存的数据将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.destroyEditor()
        done()
      }).catch(() => {})
    },
    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (!newVal) {
        // 对话框关闭时销毁编辑器
        this.destroyEditor()
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前销毁编辑器实例
    this.destroyEditor()
  }
}
</script>

<style scoped>
.agreement-container {
  padding: 20px;
}
.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.editor-container {
  border: 1px solid #ccc;
  z-index: 10;
  min-height: 400px;
}
</style> 